import React from 'react'
import { Route, Routes } from '@front/squirtle'

import VoucherList from './List'
import VoucherDetails from './Details'

const VoucherPage = () =>
  <Routes>
    <Route index element={<VoucherList />} />
    <Route path='/create' element={<VoucherDetails />} />
    <Route path='/:voucher_id' element={<VoucherDetails />} />
  </Routes>

export default React.memo(VoucherPage)
